// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AssessmentWaitController from "./assessment_wait_controller"
application.register("assessment-wait", AssessmentWaitController)

import CandidateQuickFindController from "./candidate_quick_find_controller"
application.register("candidate-quick-find", CandidateQuickFindController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import DetailsDropdownController from "./details_dropdown_controller"
application.register("details-dropdown", DetailsDropdownController)

import MirrorBannerController from "./mirror_banner_controller"
application.register("mirror-banner", MirrorBannerController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import CheckboxSummaryController from "./checkbox_summary_controller"
application.register("checkbox-summary", CheckboxSummaryController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
